import { injectGlobal } from "styled-components";
import "font-awesome/css/font-awesome.css";
import BgHeader from "../assets/header-profile.png";
import BgHeader2 from "../assets/header-profile2.jpg";
import BgHeader3 from "../assets/header-profile3.jpg";
import BgHeader4 from "../assets/header-profile4.jpg";
import BgHeader5 from "../assets/header-profile5.jpg";
import BgHeader6 from "../assets/header-profile6.jpg";
import ArrowDropDownIcon from "../assets/baseline-arrow_drop_down-24px.svg";
import ArrowLeft from "../assets/angle-left-solid.svg";
import ArrowRight from "../assets/angle-right-solid.svg";
import PlusCircle from "../assets/plus-circle-solid.svg";
import Plus from "../assets/plus.svg";

let fontSize = localStorage.getItem("@ecorban-app:font-size")
  ? localStorage.getItem("@ecorban-app:font-size") + "px"
  : 10 + "px";

injectGlobal`
  * {
    margin:0;
    padding:0;
    box-sizing: border-box;
    outline: 0;
  }
  form {
    input, select, textarea {
      color: #000000;
      font-weight: 400;
    }
  }

  #main-content {
    height: auto !important;
  }

  #main-content-small {
    max-width: 1020px;
    margin:0 auto;
    height: auto !important;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-display:block;
    src: local('Roboto Light'), local('Roboto-Light'), url(https://fonts.gstatic.com/s/roboto/v15/Hgo13k-tfSpn0qi1SFdUfZBw1xU1rKptJj_0jans920.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-display:block;
    src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v15/oMMgfZMQthOryQo9n22dcuvvDin1pK8aKteLpeZ5c0A.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-display:block;
    src: local('Roboto Medium'), local('Roboto-Medium'), url(https://fonts.gstatic.com/s/roboto/v15/RxZJdnzeo3R5zSexge8UUZBw1xU1rKptJj_0jans920.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-display:block;
    src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v15/d-6IYplOFocCacKzxwXSOJBw1xU1rKptJj_0jans920.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
  }

  html {
    font-size: ${fontSize};
  }

  html, body, #root {
    height: 100%;
  }

  svg {
    font-size: 2.4rem !important;
  }

  .recharts-surface {
    font-size: 1rem !important;
  }

  li[role="menuitem"] {
    height: 2.4rem !important;
    padding-left: 1.6rem !important;
    padding-right: 1.6rem !important;
  }

  .hamburguer {
    background-color: ${
      localStorage.getItem("@ecorban-app:theme")
        ? localStorage.getItem("@ecorban-app:theme")
        : "#2f4050"
    } !important;
    min-width: 0 !important;
    min-height: 0 !important;
    border: 0 !important;
    height: auto !important;
    padding: 1rem 1.5rem !important;

    box-shadow: none !important;

    i {
      font-size: 1.4rem !important;
    }
  }

  body {
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    color: rgba(0, 0, 0, 0.9);
    font-family: 'Roboto', sans-serif;
    background-color: #ECEFF1;
    overflow: hidden;
  }

  span {
    &.messages {
      font-size: 1.4rem;
      line-height: 2rem;
      font-weight: bold;
      display: block;
      display: flex;
      align-items: center;

      span {
        margin-left: 1rem;
        margin-top: .3rem;
      }

      i {
        font-size: 2.4rem !important;
        &.alert {
          color: #f86c6b;
        }

        &.green {
          color: #1ab394;
        }

        &.blue {
          color: #1890ff;
        }
      }
    }


    &.markdown {
      padding: 1rem;
      display: block;
      background: rgba(0, 0, 0, 0.7);
      color: #ffff;
    }
  }

  .highlight {
    color: #e2dd4c;
    margin-left: .1rem;
  }

  p {
    font-size: 1.4rem;
  }

  small {
    font-size: 1.2rem;
  }
  .checkbox-description {
   svg {
      font-size:1.4rem !important;
    }
  }

  .fieldsetLabel {
    .error-span {
      color: #f86c6b !important;
      display: none;
      text-transform: uppercase;
    }

    &.error {
      border: 2px solid #f86c6b;

      legend {
        color: #f86c6b !important;
      }

      svg {
        color: #f86c6b !important;
      }

      .checkbox-description {
        color: #f86c6b !important;
      }

      input {
          border-color: #f86c6b;
          color: #f86c6b !important;

          &:focus {
            -webkit-box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
            -moz-box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
            box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
          }
      }

      .error-span {
        font-size: 1.1rem;
        margin-top: 2rem;
        margin-bottom: 1rem;
        display: block;

        &.label-grid {
          margin-top: 0;
        }
      }
    }
  }

  .margin-auto-btn {
    position: relative;
    margin: 0 auto;
    display: block;
  }

  .warn {
    text-align: center;
    margin-top: 1rem;
    padding: 2rem;
    background: #fffee1;
    border: thin solid #f5f3b8;
    border-radius: 5px;
  }

  label,
  .spanLabel {
    display:flex;
    flex-grow: 1;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 400;
    transition: all .3s ease;
    font-weight: bold;

    span {
      display: none;
    }

    &.error {
      color: #f86c6b !important;
      input,
      textarea,
      .p-disabled,
      .p-enabled,
      select {
          border-color: #f86c6b;
          color: #f86c6b !important;

          &:focus {
            -webkit-box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
            -moz-box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
            box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
          }
      }

      .noValidate {
          color: rgba(0, 0, 0, 0.7) !important;
          border: .13rem solid #c2cfd6 !important;

          &:focus {
            -webkit-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
            -moz-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
            box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
          }
      }

      span {
        font-size: 1.1rem;
        margin-top: .5rem;
        display: block;

        &.label-grid {
          margin-top: 0;
        }
      }
    }


    &.sufix {
      position: relative;
      &:after {
        position: absolute;
        right: -.7rem;
        top: 50%;
      }
    }

    &.sufix-n {
      position: relative;
      &:after {
        position: absolute;
        right: -1.3rem;
        top: 50%;
      }
    }

    &.sufix-equal {
      &:after {
        content:"="
      }
    }

    &.select-base-calc {
      min-width: 175px;
    }

    &.sufix-plus {
      &:after {
        content:"+"
      }
    }

    &.sufix-vezes {
      &:after {
        content:"*"
      }
    }
  }

  .error-text {
      background: #f86c6b !important;
      color: #fff;
      padding: .3rem .65rem;
      border-radius: 50%;
    }

  input,
  textarea,
  select {
    background-color: #ffffff;
    height: 4rem;
    font-size: 1.4rem;
    padding: 1rem;
    color: rgba(0, 0, 0, 0.8);
    border: .13rem solid #c2cfd6;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    flex-grow: 1;
    width: 100%;
    margin-top: .3rem;
    border-radius: 3px;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    transition: all .3s ease;
    text-transform: uppercase !important;
    resize: none;
    appearance: none;
      -webkit-appearance: none;

    &:hover,
    &:focus {
      border-color: #2f4050;
    }

    &:focus {
      -webkit-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
      -moz-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
      box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.input-busca-filtro {
      border: thin solid rgba(0, 0, 0, 0.12);
      height: auto;
      padding-left: 3.5rem;
    }
  }

  .input-busca-div {
    position: relative;

    svg {
      position: absolute;
      left: .7rem;
      top: 1rem;
    }
  }

  .display-block {
    display: block;
  }

  textarea {
    height: auto;
  }

  button {
    height: 4.5rem;
    font-size: 1.4rem !important;
    padding: 0 1rem;
    text-transform: none !important;
    font-weight: 400 !important;

    &.submit {
      &:hover {
        background: #1b9f84 !important;
      }

      &:active {
        // box-shadow: 0 3px 5px 2px rgba(103, 106, 108, .3) !important;
      }

    }

    i {
      font-size: 2rem !important;
      color: #ffffff;
    }

    &.border {
      border: thin solid rgba(0, 0, 0, 0.1);
    }

  }

  hr {
    margin:0;
    padding:0;
    border:0;
    border-bottom: 1px solid #c2cfd6;
    margin-top: 1.5rem;

  }

  a {
    font-size: 1.4rem;
    color: #1ab394;
  }

  .content-left {
    margin-left: -25rem;
    width: calc(100% - 25rem);
  }

  .content-left-fit {
    margin-left: -6.9rem;
    width: calc(100% - 6.9rem);
  }

  .container-header {
    max-height: 20.5rem;
  }

  .drawerHeader {
    display: flex;
    align-items: center;
    height: 10.9rem;
    min-height: 10.9rem;
    padding: 2rem;
    transition: all .2s ease;
    background: ${
      localStorage.getItem("@ecorban-app:theme") === "#2f4050" ||
      localStorage.getItem("@ecorban-app:theme") === null
        ? `url(${BgHeader})`
        : localStorage.getItem("@ecorban-app:theme") === "#333333"
        ? `url(${BgHeader2})`
        : localStorage.getItem("@ecorban-app:theme") === "#342f50"
        ? `url(${BgHeader3})`
        : localStorage.getItem("@ecorban-app:theme") === "#752828"
        ? `url(${BgHeader4})`
        : localStorage.getItem("@ecorban-app:theme") === "#2f5047"
        ? `url(${BgHeader5})`
        : localStorage.getItem("@ecorban-app:theme") === "#1a4c7b"
        ? `url(${BgHeader6})`
        : null
    };
    .avatar-header {
      border: thin solid rgba(255,255,255, 2);
    }
  }

  .fitMenu {
    width: 6.9rem;

    .drawerHeader {
      height: 6rem;
      min-height: 6rem;
      padding-left: 1.4rem;
    }

    .avatar-header {
      width: 4rem !important;
      height: 4rem !important;
    }

    .logo-full {
      opacity: 0;
    }

    .logo-emblema {
      opacity: 1;
    }

    > div {
      width: 6.9rem;
    }

    p {
      min-width: 25rem;
      overflow: hidden;
      opacity: 0;
    }

    .fa-angle-left {
      -webkit-transform: rotate(-180deg);
      transform: rotate(-180deg);
    }
  }

  .app-bar {
    box-shadow: none !important;
    border-bottom: 1px solid rgba(0,0,0,0.12);
    position: relative !important;

    & > div:first-child {
      min-height: 4.8rem !important;
    }

    button {
      min-width: auto !important;

      &[aria-selected="true"] {
        color: #1890ff;
      }

      span {
        font-size: 1.4rem;
        text-transform: none;
      }

      span:nth-child(2) div {
        background-color: red;
      }
    }

    a {
      min-width: auto !important;
      min-height: 4.8rem !important;
      max-width: 290px;

      &[aria-selected="true"] {
        color: #1890ff;
      }

      span {
        font-size: 1.4rem;
        text-transform: none;
        display: flex;
        flex-direction: row;
        padding: .6rem 2rem !important;
        padding-right: 1.6rem !important;

        svg {
          font-size: 1.7rem !important;
          transition: color .2s ease;

          &:hover {
            color: #2f4050 !important;
          }
        }

        &>span {
          padding:0 !important;
          order: -1;
          margin-right: .8rem !important;
        }
      }

      span:nth-child(2) div {
        background-color: red;
      }
    }

    .tabsIndicator {
      background-color: #1890ff;
    }

  }

  .tooltip {
    font-size: 1.2rem !important;
    background-color: rgba(47, 64, 80, 1) !important;
  }

  .menu-suspenso {
    li {
      font-size: 1.4rem !important;
      width: 100%;
    }

    a {
      color: rgba(0,0,0, .8);
      text-decoration: none;
      display: flex;
      align-items: center;

      .notify {
        color: #ffffff;
        width: 2rem !important;
        height: 2rem !important;
        border-radius: 50%;
        background-color: #f86c6b;
        margin-left: 1rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-size: .9rem !important;
        }
      }
    }

    span {
      font-size: 1.4rem !important;
    }
  }

  .badge-button {
    height: 4rem !important;
    width: 4rem !important;

    i {
      color: #2f4050;
    }
  }

  .badge {
    span {
      background-color: #1890ff;
    }

    &.badge-alert {
      span {
        background-color: #f86c6b;
        font-size: 1.1rem;
        top: -1.1rem;
        width: 2.2rem;
        right: -1.1rem;
        height: 2.2rem;
      }
    }
  }

  tr {
    height: 4rem !important;

    button {
      height: 3rem !important;
      width: 3rem !important;
      font-size: 2rem !important;
    }
  }

  th,
  td,
  .tableFooter {
    font-size: 1.2rem !important;
    text-transform: uppercase !important;
    color: rgba(0, 0, 0, 0.9) !important;

    &:last-child {
      text-align: right;

      .tags-container {
        justify-content: center;
      }
    }

    &:first-child {
      text-align: left;
    }

    span {
      font-size: 1.2rem !important;
      text-transform: none !important;
    }
  }

  .sem-bordas {
    td, th {
      border-bottom: 0 !important;
    }
  }

  th {
    text-transform: none !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;

    &.align-center {
      text-align: center;
    }
  }

  td {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: .5rem !important;
    padding-bottom: .5rem !important;

    span {
      // text-transform: uppercase !important;

      &.td-color {
        padding: .5rem;
        min-width: 7rem;
        display: inline-block;
        text-align: center;
        border-radius: 3px;
        font-size: 1rem !important;
        color: transparent;
        font-weight: 700;
      }
    }

    &.align-center {
      text-align: center;
    }
  }

  tr.not-sum {
    opacity: .5;
  }

  .checkbox-label {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;

    &.checkbox-label-padding {
      padding: 3rem;
    }

    &.display-inline-block {
      display: inline-block;
    }

    input {
      position: relative;
      left: -2.4rem;
    }

    i {
      justify-self: flex-end;
      margin-left: auto !important;
      font-size: 1.8rem;
    }

    .checkbox-description {
      display: inline-block;
      left: -1.5rem;
      position: relative;
      cursor: pointer;
    }

    .checkbox-description-disabled {
      display: inline-block;
      left: -1.5rem;
      position: relative;
      color: rgba(0,0,0, .3);
      cursor: disabled;
    }
  }

  .check {
    height: auto !important;

    &:checked,
    &.checked {
      color: #1890ff !important;
    }
  }

  .checkbox-cell {
    width: 4.8rem !important;
  }

  .modal {
    display: flex;
    justify-content: center;
    align-items: center;

    &.modal-minimizavel {
      .modalHeader {
        display:flex;
        align-items: center;

        button {
          color: #ffffff;
          margin-left: auto;
        }
      }
    }



    div[role='document'] {
      min-width: auto;
      max-width: 120rem;
      position: absolute;
      // max-height: 80rem;
      border-radius: 5px;
      box-shadow: 0 3px 5px 2px rgba(103, 106, 108, .3) !important;

      .modalHeader {
        padding: 2rem;
        background-color: ${
          localStorage.getItem("@ecorban-app:theme")
            ? localStorage.getItem("@ecorban-app:theme")
            : "#2f4050"
        };
        border-radius: 5px 5px 0 0;
        font-size: 1.4rem;
        color: #ffffff;
        font-weight: 700;
        text-transform: uppercase;
        cursor: move;

        &.modal-metas {
          width: 120rem;
        }
      }

      .modalBody {
        padding: 2rem;
        background-color: #f5f5f5;
        border-radius: 0 0 5px 5px;
        font-size: 1.4rem;
        color: #ffffff;
        font-weight: 700;
        position: relative;
        max-height: calc(85vh - 6rem);
        overflow-y: auto;

        p {
          color: rgba(0,0,0, .6);
          font-weight: normal;
          text-transform: none;
        }

        &.modal-grupos {
          min-width: 49rem;
          min-height: 77vh;
        }

        &.modal-lojas {
          width: 100rem;
          min-height: 73vh;
        }

        &.modal-grupos-repasses {
          width: 86rem;
        }

        &.modal-extrato {
          min-width: 67.2rem;
        }

        &.categorias-extrato {
          min-width: 55.5rem;
        }

        &.modal-regioes {
          min-height: 73vh;
        }

        &.modal-tabelas {
          min-height: 73vh;
          min-width: 99.5rem;

          .label-grid.width-auto {
            justify-content: flex-start;

            label {
              flex-grow: 0;

              .i-name {
                width: 48rem;
                max-width: 100%;
              }
            }

          }
        }

        &.modal-campanha {
          .el-transfer-panel {
            min-width: 27rem;
          }
        }

        &.modal-status {
          min-width: 70rem;
          min-height: 77vh;
        }

        &.modal-rate {
          min-width: 70rem;
        }

        &.modal-usuarios {
          min-width: 100rem;
          min-height: 76.8vh;
        }

        &.modal-settings {
          min-width: 55rem;
          min-height: 76.8vh;
        }

        &.modal-local-working {
          min-width: 90rem;
          min-height: 76.8vh;
        }

        &.modal-clientes {
          width: 100rem;
        }

        &.modal-metas {
          width: 120rem;
          .el-transfer-panel {
            width: 44%;
          }
        }

        &.modal-docs {
          width: 100rem;
        }

        &.modal-status {
          width: 100rem;
        }

        &.modal-comissionamento {
          width: 93rem;
        }

        label {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }

    &.modal-big {
      div[role='document'] {
        min-width: 100rem;
        max-width: 96%;
      }
    }

    &.modal-big-big {
      div[role='document'] {
        min-width: 140rem;
        max-width: 96%;

        .modalBody {
          background-color: #ffffff;
        }
      }
    }

    &.max-width-auto {
      div[role='document'] {
        min-width: 100rem;
        max-width: none;
      }
    }
  }

  .modalStore {
    .modalBody {
      min-width: 80rem;
    }
  }

  .i-button {
    max-width: 4rem;
  }

  fieldset {
    .align-self-center.i-button-big {
      max-width: 15rem;

      button {
        padding: .9rem 1rem !important;
      }
    }
  }

  .i-name {
    max-width: 40rem;
  }

  .i-subcategoria {
    width: 40rem;
  }

  .i-name-receipt {
    width: 30rem;
  }

  .i-code {
    max-width: 9.2rem;
  }

  .i-initial_interval,
  .i-finish_interval {
    width: 8rem;
  }

  .i-phone {
    width: 14rem;
  }

  .i-started_at,
  .i-finished_at {
    max-width: 11rem;
  }

  .i-time_date {
    width: 14rem;
  }

  .i-started_at-big {
    max-width: 19rem;
  }

  .i-phone {
    max-width: 14rem;
  }

  .i-percent {
    width: 10rem;
  }

  .i-money {
    width: 12rem;
  }

  .i-zipcode {
    width: 10.2rem;
  }

  .i-address {
    width: 30rem;
  }

  .i-number {
    width: 6rem;
    max-width: 6rem;
  }

  .i-number-big {
    width: 8rem;
    max-width: 8rem;
  }

  .i-cpf_cnpj {
    max-width: 24rem;
  }

  .i-complement {
    width: 14rem;
  }

  .i-auto {
    width: auto;
  }

  .i-percent-rp {
    max-width: 7rem;
    min-width: 7rem;
  }

  .i-value-rp {
    max-width: 11rem;
    min-width: 11rem;
  }

  .modal-gerar-repasses {
    .i-value-rp {
      max-width: 8rem;
      min-width: 8rem;
    }

    input, textarea, select {
      font-size: 1.2rem !important;
    }

    input {
      &.big-font {
        font-size: 1.6rem !important;
      }
    }
  }

  .black {
    color: rgba(0,0,0) !important;
  }

  .headerButton {
    width: 3.5rem !important;
    height: 3.5rem !important;
  }

  .alert-dialog {

    h2 {
      font-size: 2rem !important;
    }

    p {
      font-size: 1.4rem !important;
    }
  }

  .search-input {
    position: relative;
    margin-left: .8rem;

    svg {
      position: absolute;
      left: .7rem;
      top: 50%;
      margin-top: -1rem;
      font-size: 2rem !important;
      color: rgba(0,0,0) !important;
    }

    input,
    textarea,
    select {
      min-height: 3.5rem;
      margin: 0;
      /* background: transparent; */
      background: #ffffff;
      border-color: rgba(0,0,0, .2);
      /* border-color: transparent; */
      font-size: 1.4rem;
      width: 45rem;
      padding-left: 3.7rem;
      appearance: none;
      -webkit-appearance: none;

      &:focus {
        background: #ffffff;
        border-color: rgba(0,0,0, .2);
        box-shadow: none;
      }

      ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        font-size: 1.2rem;
        text-transform: none;
      }

      ::-moz-placeholder { /* Firefox 19+ */
        font-size: 1.2rem;
        text-transform: none;
      }

      :-ms-input-placeholder { /* IE 10+ */
        font-size: 1.2rem;
        text-transform: none;
      }

      :-moz-placeholder { /* Firefox 18- */
        font-size: 1.2rem;
        text-transform: none;
      }
    }
  }

  select {
    background-image: url(${ArrowDropDownIcon});
    background-repeat: no-repeat;
    background-position: center right;
    padding-right: 3rem;

    &:disabled {
      background-color: rgb(235, 235, 228);
      background-image: none;
    }
  }

  .alert-dialog-content {
    min-width: 60rem !important;
  }

  .alert-dialog-actions {
    padding-bottom: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;

    .undefined {
      min-height: 4.3rem;
    }
  }

  .tags-container {
    display: flex;
    flex-direction: row;
    padding: .5rem 0;

    &.big {
      top: 5px !important;
      align-items: center;
      padding: 0;
      justify-content: center;

      .tag {
        width: 3rem;
        height: 3rem;


        i {
          font-size: 1.8rem;
          position: relative;
          top: 2px;
        }
      }
    }

    .tag {
      padding: .5rem .7rem;
      background-color: ${
        localStorage.getItem("@ecorban-app:theme")
          ? localStorage.getItem("@ecorban-app:theme")
          : "#2f4050"
      };
      border-radius: 3px;
      color: #ffffff;
      font-weight: 700;
      font-size: 1rem !important;
      width: auto;
      position: relative;

      &:not(:last-child) {
        margin-right: 1rem;
      }

      &:hover {
        .tag-child {
          display: block;
        }
      }

      .tag-child {
        position: absolute;
        right: 0;
        top: 0;
        color: rgba(0, 0, 0, 0.87);
        padding: 1rem;
        background: #ffffff;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
        border-radius: 3px;
        margin-bottom: 1rem;
        min-width: calc(100% + 12rem);
        display: flex;
        flex-direction: column;
        display: none;
        z-index: 10;

        &.tag-child-big {
          min-width: calc(100% + 45rem);

          table {
            width: 100%;
            border-spacing: 0;

            tr {
              height: 3rem !important;

              span {
                padding: 0;
              }

              &:last-child {
                td {
                  border-bottom: 0;
                }
              }
            }

            &.padding-table {
              td {
                &.number {
                  text-align: right !important;

                  span {
                    font-size: 1.3rem !important;
                  }
                }
              }
            }

            td {
              border-bottom: thin solid rgba(0,0,0, .2);
            }
          }
        }

        .tag-row {
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          color: rgba(0,0,0, .9);

          &:not(:last-child) {
            border-bottom: thin solid rgba(0,0,0, .1);
            padding-bottom: .3rem;
          }

          &:not(:first-child) {
            padding-top: .3rem;
            color: rgba(0,0,0, .6);
          }

          span {
            &:not(:last-child) {
              padding-right: .5rem;
            }
          }
        }

        span {
          font-size: 1rem !important;
          word-wrap:  unset;
          white-space: nowrap;
        }
      }
    }
  }

  #filtros {
    transition: all .3s ease;
    overflow: hidden;
  }


  .padding-zero {
    padding: 0 !important;
  }

  .hide {
    display: none;
  }

  .tag-hover {
    position: absolute;
    right: calc(100% + 1rem);
    top: 50%;
    margin-top: -1.65rem;
    color: rgba(0, 0, 0, 0.87);
    padding: 1rem;
    background: #ffffff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    margin-bottom: 1rem;
    min-width: calc(100% + 15rem);
    display: flex;
    flex-direction: column;
    z-index: 10;
    text-align: left;
    display: none;

    .tag-child {
      font-size: 1rem !important;
      font-weight:  500;
      color: rgba(0,0,0, .7);

      &:not(:last-child) {
        border-bottom: thin solid rgba(0,0,0, .15);
        margin-bottom: .4rem;
        padding-bottom: .4rem;
      }
    }
  }

  .lista-negra {
    position: relative;
    cursor: default;

    .tag-hover {
      font-size: 1rem !important;
      font-weight: 500;
      color: rgba(0,0,0, .7);
    }

    &:hover {
      .tag-hover {
        display: flex;
      }
    }
  }

  .total-borderos {
    cursor: default;

    &:hover {
      .tag-hover {
        display: flex;
      }
    }
  }

  .timer,
  .td-color {
    cursor: context-menu;
  }

  .user-acess,
  .s-docs,
  .timer,
  .td-color {
    position: relative;

    .tag-child {
      position: absolute;
      right: calc(100% + 1rem);
      top: 50%;
      margin-top: -1.65rem;
      color: rgba(0, 0, 0, 0.87);
      padding: 1rem;
      background: #ffffff;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
      border-radius: 3px;
      margin-bottom: 1rem;
      min-width: calc(100% + 12rem);
      display: flex;
      flex-direction: column;
      display: none;
      z-index: 10;

      .tag-row {
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        color: rgba(0,0,0, .9);

        &:not(:last-child) {
          border-bottom: thin solid rgba(0,0,0, .1);
          padding-bottom: .3rem;
        }

        &:not(:first-child) {
          padding-top: .3rem;
          color: rgba(0,0,0, .6);
        }

        span {
          &:not(:last-child) {
            padding-right: .5rem;
          }
        }
      }

      span {
        font-size: 1.3rem !important;
        word-wrap:  unset;
        white-space: nowrap;
      }
    }

    &:hover {
      .tag-child {
        display: block;
      }
    }
  }

  .user-acess .tag-child {
    min-width: 30px;
  }

  .modal div[role='document'] .modalBody {
    .s-docs {
      cursor: pointer;
    }
  }

  .td-color {
    .tag-child {
      text-align: left;
    }
  }


  .label-grid {
    display: flex !important;
    align-items: flex-start;
    justify-content: space-between;

    label,
    .spanLabel {
      flex-grow: 1;
    }
  }

  .comunicado-html {
    padding: 1rem;
    background: rgb(235, 235, 228);
    margin-top: .5rem;
    border: .13rem solid #c2cfd6;
    border-radius: 3px;

    span {
      display: inline-block !important;
    }
  }

  fieldset {
    padding: 2rem;
    padding-bottom: .5rem;
    border: 2px solid rgba(0,0,0,.2);
    max-width: 100%;

    legend {
      color: rgba(0,0,0,.5);
      font-weight: bold;
      font-size: 1.4rem;
      text-transform: uppercase;
      padding-left: 1rem;
      padding-right: 1rem;
    }

    hr {
      border-bottom: 1px solid rgba(0,0,0,.2);
      margin-bottom: 1.5rem;
    }

    p,
    legend,
    .align-self-center {
      button {
        height: auto !important;
        min-height: 0 !important;
        width: auto !important;
        min-width: 0 !important;
        padding: .7rem 1rem !important;

        svg {
          font-size: 2rem !important;
        }
      }
    }

  }

  .inner {
    padding: 1.5rem 7rem;

    p {
      text-transform: uppercase;
      color: rgba(0,0,0,0.6);
      font-size: 1.2rem;
      font-weight: normal;
    }
  }

  .react-datepicker {
    font-family: 'Roboto', sans-serif !important;
    font-size: 1.4rem !important;
  }

  .react-datepicker__portal .react-datepicker__day-name, .react-datepicker__portal .react-datepicker__day, .react-datepicker__portal .react-datepicker__time-name {
    width: 5rem !important;
    line-height: 5rem !important;
  }

  .react-datepicker__portal .react-datepicker__current-month, .react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.4rem !important;
  }

  .react-datepicker__month {
    margin: 1.4rem !important;
  }

  .react-datepicker__day--sun {
    color: #f86c6b !important;
  }

  .react-datepicker__day--outside-month {
    color: rgba(0,0,0, .2) !important;
    pointer-events: none;
  }


  .list span {
    font-size: 1.4rem !important;
  }

  .permissions-list {
    font-size: 1.4rem;
    color: rgba(0, 0, 0, 0.54);
    font-weight: normal;
    list-style: none;
    width: 100%;

    .topic-permission {
      padding: 2rem 1rem;
      border: thin solid rgba(0,0,0, .2);
      border-radius: 3px;

      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }

    .topic-permission-div {
      margin: 1rem;
      padding: .8rem 3.3rem;
      padding-left: 4rem;
    }

    ul {
      list-style: none;
      margin-top: 1rem;

      li {
        padding-left: 3.3rem;
        margin-top: .5rem;
      }
    }
  }

  .summary-check {
    position: absolute !important;
    top: 1.7rem;
    left: 1rem;
    transition: top 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  div[aria-hidden="true"] {
    .summary-check {
      top: 1rem ;
    }
  }

  .panelSumary {
    padding: 0 .7rem !important;
    padding-left: 5.5rem !important;
    min-height: 0 !important;
  }

  span.tel {
    width: 11rem;
  }

  .fa-lg {
    font-size: 2.2rem !important;
  }

  .s-docs {
    position: relative;
    cursor: pointer;

    &:before {
      position: absolute;
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      color: #000;
      font-weight: 700;
      font-size: .9rem;
      text-align: center;
      right: -0.5rem;
      top: -.4rem;
      pointer-events: none;
    }
  }

  .has-files {
    color: rgba(0,0,0, .2);
  }

  .docs-ok:before {
    content: "✓";
    background: #1ab394;
  }

  .docs-not-ok:before {
    content: "!";
    background: #a6954e;
  }

  .docs-not-ok-warning:before {
    content: "*";
    background: #f86c6b;
    font-size: 1.3rem;
  }

  .select-input {
    cursor: pointer;
    text-transform: none !important;
    background: #ffffff;
    background-image: url(${PlusCircle});
    background-repeat: no-repeat;
    background-position: calc(100% - 1rem) center;
    background-size: 2rem;

    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      text-transform: none !important;
    }

    ::-moz-placeholder { /* Firefox 19+ */
      text-transform: none !important;
    }

    :-ms-input-placeholder { /* IE 10+ */
      text-transform: none !important;
    }

    :-moz-placeholder { /* Firefox 18- */
      text-transform: none !important;
    }
  }

  .image-crop {
    img {
      max-width: 100%;
    }
  }

  .avatar {
    width: 30rem;
    height: 30rem;
    margin: 0 auto;
  }

  .avatar-listagem {
    width: 4.5rem;
    height: 4.5rem;
    overflow: hidden;
    border-radius: 50%;

    img {
      width: 100%;
    }
  }

  .botao-enviar-nova {
    margin: 0 auto;
    margin-top: 2rem;
    display: block;
    background: #1b9f84 !important;
    color: #ffffff;
    border: 0;
    border-radius: 3px;
    cursor: pointer;
  }

  .logotipo {
    width: 100%;
    height: 30rem;
    margin: 0 auto;
  }

  .img-preview {
    width: 30rem;
    height: 30rem;
    background-color: rgba(0,0,0, .2);
    border-radius: 50%;
    position: absolute;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    left: 50%;
    margin-left: -15rem;
  }

  .dropzone-logo {
    position: relative;
    border:thin solid rgba(0,0,0, .2);
  }

  .image-crop-controls {
    button:last-child {
      height: 3.2rem !important;
    }
  }

  .logo-preview {
    width: 100%;
    height: 30rem;
    position: absolute;
    overflow: hidden;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-height: 100%;
    }
  }

  .drop-files {
    min-width: 40rem;
    font-size: 1.4rem;
    font-weight: normal;
    text-align: center;
    padding: 3rem;
    color: rgba(0,0,0, .8);
    cursor: pointer;
  }

  .padding-table-list {
    padding: 3rem;
    padding-top: 0;
  }

  .file-table-list {
    background: #ffffff;
    min-width: 40rem;

    border-radius: 3px;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    td {
      padding: 1rem;
    }

    thead {
      padding-left: 8px;
      padding-right: 8px;
      border-radius: 5px 5px 0 0;

      td {
        text-align: left;
        padding-top: 1rem;
        padding-bottom: 1rem;
        padding-left: 2rem !important;
        padding-right: 2rem !important;

        b {
          text-transform: none !important;
        }
      }
    }

    tbody {

      tr:first-child {
        td {
          border-top: 1px solid rgba(224, 224, 224, 1);
        }
      }

      td {
        border-bottom: 1px solid rgba(224, 224, 224, 1);
        vertical-align: inherit;
        text-align: left;
        vertical-align: middle;
        padding-top: 1rem;
        padding-bottom: 1rem;
        padding-left: 2rem !important;
        padding-right: 2rem !important;

        button {
          padding: 0 !important;
          min-width: 0 !important;
          min-height: 0 !important;

          svg {
            font-size: 1.6rem !important;
          }
        }
      }

      .rejected-file {
        td {
          color: #f86c6b !important;
        }
      }
    }

    small {
      display: block;
      font-size: 1.1rem;
      text-transform: none;

      &:nth-child(2) {
        margin-top: .3rem;
      }
    }

    img {
      max-width: 4rem;
      display: block;
      margin: 0 auto;
    }

    svg {
      display: block;
      margin:0 auto;
    }
  }

  .files-control {
    td {
      padding: 0 2rem 2rem 3rem !important
    }

    button {
      width: auto !important;
      height: auto !important;
    }
  }

  .load-files-content {
    width: 100%;
    height: 6px;
    background-color: rgba(24, 144, 255, .2);
    position: relative;

    span {
      height: 6px;
      transition: width .5 ease;
      display: block;
      background-color: rgba(24, 144, 255);
    }
  }

  .full-width {
    width: 100% !important;
  }

  .status-list {
    padding: 0;
    margin:0;
    list-style: none;
    color: rgba(0,0,0, .8);

    li {
      padding: 1.5rem;
      background: #ffffff;
      border-radius: 3px;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);

      &:not(:last-child) {
        margin-bottom: 1rem;
      }

      hr {
        margin-top: 1rem;
        margin-bottom: .5rem;
      }
    }

    p,
    small {
      font-weight: normal;
      text-transform: uppercase;
    }

    p {
      font-size: 1.2rem;

      margin-bottom: .5rem;
    }

    small {
      font-size: 1.1rem;
    }
  }

  #simple-dialog-title h2 {
    font-size: 2rem;
  }

  .dialog-filter {
    max-height: 30rem;
    min-width: 40rem;

    .checkbox-label {
      cursor: pointer;
    }

    &.two-columns {
      display: flex;
      flex-direction: row;



      div {
        width: 50%;

        &:first-child {
          padding-right: 20px;
        }

        &:last-child {
          padding-left: 20px;
        }
      }
    }
  }

  .repo-warning {
    text-align: center;
    padding: 5rem 1rem;
    font-size: 1.6rem;
    color: rgba(0,0,0, .4);

    svg {
      font-size: 13rem !important;
    }
  }

  .avatar-header {
    background: rgba(255,255,255, .6);
    width: 6rem !important;
    height: 6rem !important;
  }

  .dados-usuario {
    margin-left: 1rem;
    font-size: 1.4rem;
    color: #ffffff;

    span {
      position: relative;
      display: block;
      margin-top: .2rem;
      font-size: 1.2rem;
      color: rgba(255,255,255, .6);
    }

    small {
      position: relative;
      display: block;
      margin-top: .2rem;
      color: rgba(255,255,255, .6);
      font-size: 1.2rem;
      padding-left: 1.3rem;

      &:before {
        width: 1rem;
        height: 1rem;
        content:"";
        position: absolute;
        background: #1ab394;
        border-radius: 50%;
        left: 0;
        top: 50%;
        margin-top: -.5rem;
      }
    }
  }

  .botao-propostas {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0.5rem 1rem;
    color: #ffffff;
    background: #2f4050;
    border-radius: 5px;
    cursor: pointer;
    height: 2.9rem;
    font-weight: normal;
    text-transform: none;
    max-width: 10rem;
    text-align: center;
    justify-content: center;
  }

  .width-ver {
    width: 12rem;
  }

  .name-user {
    font-weight: bold;
    padding-left: 5rem;
    color: #2f4050;
  }

  .name-report {
    font-weight: bold;
    color: #2f4050;
    cursor: pointer;
  }

  .name-report-sub {
    font-weight: bold;
    color: #2f4050;
    padding-left: 2rem;
    cursor: pointer;
  }

  .nome-usuario {
    text-transform: uppercase;
  }

  .truncate {
    width: 10rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  .truncate-comunicado {
    max-width: 25rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  .truncate-name {
    max-width: 13rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  .applyFilters {
    background: #1890ff !important;
    color: #ffffff !important;
  }

  .empresa-left {
    max-width: 84rem;
  }

  .modal-sales {
    svg,
    span {
      color: rgba(0,0,0,0.65) !important;
    }

    button {
      span {
        color: #ffffff !important;
      }
    }
  }

  .file-table-list thead td b.capitalize {
    text-transform: capitalize !important;
  }


  .icon-button-small {

    svg {
      font-size: 18px !important;
    }
  }


  .text-button {
    width: 30px !important;
    height: 30px !important;
  }

  .flip {
    translate: transform .5s ease;
    transform: rotate(180deg);
  }

  .button-size {
    width: 3.5rem !important;
    height: 3.5rem !important;
  }

  .default-link {
    text-decoration: none !important;
  }

  .dashboard-title {
    font-weight: bold;
    font-size: 1.7rem;
    margin-bottom: 2rem;
  }

  .topic {
    font-weight: bold;
  }

  .topic-small {
    line-height: 2.2rem;
  }

  .inactived {
    opacity: 0.3;

    button {
      display: none !important;
    }
  }

  .tabela-Lancamentos {
    .atrasado {
      background: rgba(248,108,107, .07);
    }

  }

  .change-category-name {
    input {
      pointer-events: auto !important;
    }
  }

  .new-tag {
    font-size:.9rem;
    font-weight: bold;
    color: #ffffff;
    padding: .2rem .5rem;
    background-color: #1890ff;
    border-radius: 3px;
    top: -.2rem;
    left: .2rem;
    position: relative;
  }

  .el-transfer {
    .el-transfer-panel {
      width: 40%;
    }
    .el-transfer-panel__item {
      height: 3.2rem;
      line-height: 3.2rem;
      padding-left: 1rem;
      margin-bottom:0;

      span {
        color: rgba(0,0,0, 0.85);
        display: inline-block;
        font-weight: normal;
        font-size: 1.2rem;
      }
    }
  }

  .el-transfer-panel .el-transfer-panel__footer .el-checkbox {
    padding-left: 1rem !important;

    span {
      color: rgba(0,0,0, 0.85);
      display: inline-block;
      font-weight: normal;
      font-size: 1.2rem;
    }
  }

  .red-alert {
    font-weight: bold;
    color: #f86c6b;
  }

  .green-alert {
    font-weight: bold;
    color: #1ab394 !important;
  }

  .blue-alert {
    font-weight: bold;
    color: #1890ff;
  }

  .tape {
    position: absolute;
    width: 10rem;
    height: 2.5rem;
    background: #ffffff;
    bottom: 0;
    right: 0;
  }

  .tape-2 {
    position: absolute;
    width: 10rem;
    height: 1.8rem;
    background: #ffffff;
    bottom: 1.5rem;
    right: 1rem;
  }

  .horizontal-label {
    display: flex;
    flex-direction: row;
    align-items: center;

    input {
      flex-grow: 0;
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }

  .rdw-editor-wrapper {
    color: rgba(0,0,0, .85) !important;


    .rdw-link-modal-target-option {
      span {
        display: block;
      }
    }

    input {
      box-sizing: border-box !important;
      height: 3rem !important;
      padding: 1rem .5rem !important;
      text-transform: none !important;
    }

    input[type='checkbox'] {
      width: 2rem;
      height: 4rem !important;
      padding: .9rem .5rem !important;
    }

    .rdw-link-modal,
    .rdw-image-modal,
    .rdw-emoji-modal,
    .rdw-colorpicker-modal {
      left: auto !important;
      right: 5px;
    }

    .rdw-dropdown-wrapper {
      a {
        span {
          color: rgba(0,0,0, .85) !important;
        }
      }
    }

  }

  .rdw-editor-toolbar {
    border: .13rem solid #c2cfd6 !important;
  }

  .rdw-editor-main {
    border: .13rem solid #c2cfd6;
    height: 40vh !important;
    background-color: #ffffff;
  }

  .public-DraftStyleDefault-block {
    margin: 1rem !important;
    font-weight: normal;
  }


  .el-transfer-panel__filter .el-input__inner {
    height: 40px !important;
  }

  .el-transfer-panel__list.is-filterable {
    height: 156px !important;
  }

  &.not-border-bottom {
    border-bottom: 0 !important;

    li {
      border-bottom: 0!important;
    }
  }

  .menu-comunicados {
    .menu-right {
      display: flex;
      flex-direction: column;
      height: auto !important;
      align-items: flex-start;
      margin-left: 1rem;
      line-height: 1.4rem;
    }

    li {
      padding: 1rem 0;
      height: auto !important;
      color: #1890ff;
      border-bottom: thin solid rgba(0,0,0, .2);

      &.opened {
        color: rgba(0,0,0, .8);
      }

      &.see-all {
        color: rgba(0,0,0, .7);
        justify-content: center;
        text-transform: uppercase;
        font-size: 1.2rem !important;
      }
    }
  }

  .modal-comunicados {
    p {
      color: rgba(0,0,0, .5);
    }
  }


  .modais-minimizados {
    display: flex;
    align-items: flex-end;

    .modal-minimizado {
      min-height: 4rem;
      align-items: center;
      display: flex;
      width: 23rem;
      background: #2f4050;
      border-radius: 5px 5px 0 0;
      color: #ffffff;
      font-size: 1.2rem;
      text-transform: uppercase;
      font-weight: bold;
      padding: 0 2rem;
      margin-left: 2rem;
      padding-right: 1rem;

      button {
        color: #ffffff;
        margin-left: auto;
        margin-right: 0 !important;

        svg {
          font-size: 2rem !important;
        }
      }
    }
  }

  .modal-select-convenio {
    color: rgba(0,0,0, .85) !important;

    .modalHeader {
      color: #ffffff !important;
    }


    i {
      color: #ffffff !important;
    }

    div[role='document'] {
      max-width: 70%;
      width: 70%;
    }

    .filtro-tabela-convenios {
      color: rgba(0,0,0, .85) !important;
      font-wight: normal !important;

      .filtro-opt-status {
        display: none !important;
      }
    }
  }

  .p-disabled {
    height: 4rem;
    font-size: 1.4rem;
    padding: 1rem;
    color: rgba(0,0,0,0.8);
    border: .13rem solid #c2cfd6;
    font-family: 'Roboto',sans-serif;
    font-weight: 300;
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    width: 100%;
    margin-top: .3rem;
    border-radius: 3px;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    text-transform: uppercase !important;
    resize: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-appearance: none;
    background-color: rgb(235,235,228);

    &:hover {
      border-color: #2f4050;
    }
  }

  .p-enabled {
    height: 4rem;
    font-size: 1.4rem;
    padding: 1rem;
    color: rgba(0,0,0,0.8);
    border: .13rem solid #c2cfd6;
    font-family: 'Roboto',sans-serif;
    font-weight: 300;
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    width: 100%;
    margin-top: .3rem;
    border-radius: 3px;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    text-transform: uppercase !important;
    resize: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    cursor: pointer;

    &:hover {
      -webkit-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
      -moz-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
      box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
      border-color: #2f4050;
    }
  }

  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: rgba(0, 0, 0, 0.7);
    text-transform: uppercase;
  }

  ::-moz-placeholder { /* Firefox 19+ */
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: rgba(0, 0, 0, 0.7);
    text-transform: uppercase;
  }

  :-ms-input-placeholder { /* IE 10+ */
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: rgba(0, 0, 0, 0.7);
    text-transform: uppercase;
  }

  :-moz-placeholder { /* Firefox 18- */
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: rgba(0, 0, 0, 0.7);
    text-transform: uppercase;
  }

  .cliente-card-foto {
    width: 10.5rem;
    height: 10.5rem;
    border-radius: 50%;
    background-color: rgba(0,0,0, .2);
    overflow:hidden;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTMgNTMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUzIDUzOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIGNsYXNzPSIiPjxnPjxwYXRoIHN0eWxlPSJmaWxsOiNGREZERkQiIGQ9Ik0xOC42MTMsNDEuNTUybC03LjkwNyw0LjMxM2MtMC40NjQsMC4yNTMtMC44ODEsMC41NjQtMS4yNjksMC45MDNDMTQuMDQ3LDUwLjY1NSwxOS45OTgsNTMsMjYuNSw1MyAgYzYuNDU0LDAsMTIuMzY3LTIuMzEsMTYuOTY0LTYuMTQ0Yy0wLjQyNC0wLjM1OC0wLjg4NC0wLjY4LTEuMzk0LTAuOTM0bC04LjQ2Ny00LjIzM2MtMS4wOTQtMC41NDctMS43ODUtMS42NjUtMS43ODUtMi44ODh2LTMuMzIyICBjMC4yMzgtMC4yNzEsMC41MS0wLjYxOSwwLjgwMS0xLjAzYzEuMTU0LTEuNjMsMi4wMjctMy40MjMsMi42MzItNS4zMDRjMS4wODYtMC4zMzUsMS44ODYtMS4zMzgsMS44ODYtMi41M3YtMy41NDYgIGMwLTAuNzgtMC4zNDctMS40NzctMC44ODYtMS45NjV2LTUuMTI2YzAsMCwxLjA1My03Ljk3Ny05Ljc1LTcuOTc3cy05Ljc1LDcuOTc3LTkuNzUsNy45Nzd2NS4xMjYgIGMtMC41NCwwLjQ4OC0wLjg4NiwxLjE4NS0wLjg4NiwxLjk2NXYzLjU0NmMwLDAuOTM0LDAuNDkxLDEuNzU2LDEuMjI2LDIuMjMxYzAuODg2LDMuODU3LDMuMjA2LDYuNjMzLDMuMjA2LDYuNjMzdjMuMjQgIEMyMC4yOTYsMzkuODk5LDE5LjY1LDQwLjk4NiwxOC42MTMsNDEuNTUyeiIgZGF0YS1vcmlnaW5hbD0iI0U3RUNFRCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iI0ZCRkFGQSI+PC9wYXRoPjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6IzJGNDA1MCIgZD0iTTI2Ljk1MywwLjAwNEMxMi4zMi0wLjI0NiwwLjI1NCwxMS40MTQsMC4wMDQsMjYuMDQ3Qy0wLjEzOCwzNC4zNDQsMy41Niw0MS44MDEsOS40NDgsNDYuNzYgICBjMC4zODUtMC4zMzYsMC43OTgtMC42NDQsMS4yNTctMC44OTRsNy45MDctNC4zMTNjMS4wMzctMC41NjYsMS42ODMtMS42NTMsMS42ODMtMi44MzV2LTMuMjRjMCwwLTIuMzIxLTIuNzc2LTMuMjA2LTYuNjMzICAgYy0wLjczNC0wLjQ3NS0xLjIyNi0xLjI5Ni0xLjIyNi0yLjIzMXYtMy41NDZjMC0wLjc4LDAuMzQ3LTEuNDc3LDAuODg2LTEuOTY1di01LjEyNmMwLDAtMS4wNTMtNy45NzcsOS43NS03Ljk3NyAgIHM5Ljc1LDcuOTc3LDkuNzUsNy45Nzd2NS4xMjZjMC41NCwwLjQ4OCwwLjg4NiwxLjE4NSwwLjg4NiwxLjk2NXYzLjU0NmMwLDEuMTkyLTAuOCwyLjE5NS0xLjg4NiwyLjUzICAgYy0wLjYwNSwxLjg4MS0xLjQ3OCwzLjY3NC0yLjYzMiw1LjMwNGMtMC4yOTEsMC40MTEtMC41NjMsMC43NTktMC44MDEsMS4wM1YzOC44YzAsMS4yMjMsMC42OTEsMi4zNDIsMS43ODUsMi44ODhsOC40NjcsNC4yMzMgICBjMC41MDgsMC4yNTQsMC45NjcsMC41NzUsMS4zOSwwLjkzMmM1LjcxLTQuNzYyLDkuMzk5LTExLjg4Miw5LjUzNi0xOS45QzUzLjI0NiwxMi4zMiw0MS41ODcsMC4yNTQsMjYuOTUzLDAuMDA0eiIgZGF0YS1vcmlnaW5hbD0iIzU1NjA4MCIgY2xhc3M9IiIgZGF0YS1vbGRfY29sb3I9IiMyZjQwNTAiPjwvcGF0aD4KPC9nPjwvZz4gPC9zdmc+);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom;
    position: relative;
    flex-shrink: 0;

    .blacklisted {
      position: absolute;
      width: 100%;
      height: 100%;
      content: "";
      background-color: rgba(0,0,0,.8);
      background-position: center;
      background-size: 25%;
      background-repeat: no-repeat;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUzMy4zMzMgNTMzLjMzMyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTMzLjMzMyA1MzMuMzMzOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PGc+Cgk8cGF0aCBkPSJNNTcuNDQ1LDIzMy4zMzNjLTM4LjAyMSwwLTE2LjY2Ny0xMDAsMTYuNjY3LTEwMGMtMTYuNjY3LDAsMC04My4zMzMsMzMuMzMzLTgzLjMzM2MwLTMzLjMzMywzMy4zMzMtNTAsNjYuNjY3LTUwICAgYzE0MC44MDgsMCw5MS4yODMsMzUuMjM0LDIzMy4zMzMsNTB2MjY2LjY2N2MtMTI1LjQ4LDM3LjYzOS0yNTAsMTMxLjk5MS0yNTAsMjE2LjY2NmMtMjcuNjA0LDAtMTAwLTMzLjMzMywwLTIwMCAgIGMwLDAtODMuMzMzLDAtMTAwLDBDNy40NDUsMzMzLjMzMywyNC4xMTEsMjMzLjMzMyw1Ny40NDUsMjMzLjMzM3ogTTQ0MC43NzcsMzE2LjY2N1Y1MGgtMzMuMzMzVjMzLjMzM2g2Ni42NjcgICBjMTguMzMyLDAsMzMuMzMzLDIyLjUsMzMuMzMzLDUwdjIwMGMwLDI3LjUwMS0xNS4wMDEsNTAtMzMuMzMzLDUwaC02Ni42Njd2LTE2LjY2Nkg0NDAuNzc3eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBzdHlsZT0iZmlsbDojRkZGRkZGIiBkYXRhLW9sZF9jb2xvcj0iI0VFRUJFQiI+PC9wYXRoPgo8L2c+PC9nPiA8L3N2Zz4=);
    }

    img {
      max-width: 101%;
    }
  }

  .cliente-card-header {
    display: flex;

    .cliente-card-text {
      display: flex;
      margin-left: 2rem;
      flex-direction: column;
      text-transform: uppercase;
      justify-content: center;
      width: 30rem;
      flex-shrink: 0;

      &.cliente-card-text-big {
        .name {
          width: 100% !important;
        }
      }

      .cliente-name {
        font-weight: bold;
        display: flex;
        align-items:center;
        margin-bottom: .3rem;
        font-size: 1.4rem;

        .name {
          width: 18rem;
        }

        .cliente-buttons {
          position: relative;
        }
      }

      small {
        margin-bottom: .3rem;
      }
    }

    .break-tablet {
      display: flex;
    }

    .cliente-card-summay {
      margin-left: 3rem;
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 3rem;
      flex-shrink: 1;

      &:before {
        width: 1px;
        height: 3rem;
        background-color: rgba(0,0,0, .1);
        position: absolute;
        left: -3rem;
        top: 50%;
        margin-top: -1.5rem;
        content: "";
      }

      p {
        padding: .8rem;
        background: rgba(0,0,0, .05);
        font-weight: bold;
        font-size: 1.1rem;
        color: rgba(0,0,0, .85);
        border-radius: 5px;
        margin-right: 2rem;
        text-transform: uppercase;
        display:flex;
        flex-direction: column;
        min-width: 10rem;


        span {
          padding: .2rem 1rem;
          margin-right: .2rem;
          color: #ffffff;
          font-weight: bold;
          background-color: ${
            localStorage.getItem("@ecorban-app:theme")
              ? localStorage.getItem("@ecorban-app:theme")
              : "#2f4050"
          };
          border-radius: 5px;
          margin-top: .3rem;
          font-size: 2rem;
          text-align: center;
          min-height: 2.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .finalizar-atendimento-cliente {
      span {
        display: inline-block;
        background-color: #f86c6b;
        padding: .8rem 1.4rem;
        cursor: pointer;
        border-radius: 3px;
        font-size: 1.2rem;
        color: #ffffff;
        font-weight: bold;
      }
    }

    .detalhes-cliente {
      margin-top: .4rem;
      span {
        display: inline-block;
        background-color: rgba(0,0,0,.05);
        padding: .8rem 1.4rem;
        cursor: pointer;
        border-radius: 3px;
        font-size: 1.2rem;
        color: rgba(0,0,0,.85);
        font-weight: bold;
      }
    }

    .em-atendimento {
      margin-top: .4rem;

      span {
        display: inline-block;
        background-color: #1890ff;
        padding: .8rem 1.4rem;
        cursor: pointer;
        border-radius: 3px;
        font-size: 1.2rem;
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  .cliente-card-body {
    color: rgba(0,0,0,0.6);

    .fieldset-atendimento {
      width: 100%;
      padding-bottom: 2rem;
      background-color: rgba(0,0,0,.03);
      border: 1px solid rgba(0, 0, 0, 0.12);

      textarea {
        height: 15rem;
      }

      label {
        max-width: 41rem;
      }
    }

    form {
      width: 100%;
    }
  }

  .atender-cliente {
    margin-top: .4rem;
    text-transform: uppercase;

    span {
      display: inline-block;
      background-color: #1ab394;
      padding: .8rem 1.4rem;
      cursor: pointer;
      border-radius: 3px;
      font-size: 1.2rem;
      color: #ffffff;
      font-weight: bold;
    }
  }

  .busca-header {
    margin-left: 1.3rem;
    position: relative;

    svg.search-icon {
      position: absolute;
      color: rgba(0,0,0, .3);
      left: 1rem;
      font-size: 2rem !important;
    }

    svg.info-icon {
      position: absolute;
      color: rgba(0,0,0, .6);
      right: 1rem;
      top: .92rem;
      font-size: 1.6rem !important;
    }

    form {
      width: 35rem;

      input {
        height: 3.6rem;
        margin: 0 !important;
        background: rgba(0,0,0, .01);
        padding-left: 3.5rem;
        padding-right: 3rem;
        font-size: 1.35rem;

        &.error {
          border-color: #f86c6b;

          &:focus {
            -webkit-box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
          -moz-box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
           box-shadow: 0px 0px 5px 0px rgba(248,108,107,0.8);
          }
        }

        ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
          text-transform: none;
          font-size: 1.3rem;
        }

        ::-moz-placeholder { /* Firefox 19+ */
          text-transform: none;
          font-size: 1.3rem;
        }

        :-ms-input-placeholder { /* IE 10+ */
          text-transform: none;
          font-size: 1.3rem;
        }

        :-moz-placeholder { /* Firefox 18- */
          text-transform: none;
          font-size: 1.3rem;
        }
      }

    }

  }

  .detalhes-cliente {
    margin-top: .4rem;
    span {
      display: inline-block;
      background-color: rgba(0,0,0,.05);
      padding: .8rem 1.4rem;
      cursor: pointer;
      border-radius: 3px;
      font-size: 1.2rem;
      color: rgba(0,0,0,.85);
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .snack-atendimento {
    align-items: flex-start;
    cursor: pointer;

    fieldset {
      margin-top: 30px;
      padding-bottom: 20px;
      border-radius: 5px;
      background: #ECEFF1;
    }

    &>div {
      align-items: flex-start !important;

      &:hover {
        max-height: auto;
      }
    }

    .cliente-card-foto {
      width: 4.5rem ;
      height: 4.5rem ;
      margin-right: 2rem;
    }

    .messages {
      line-height: 1.3rem;
      span {
        text-transform: uppercase;
        margin-left: 0;
      }

      .messages-columns {
        flex-direction: column !important;
        align-items: flex-start;
      }
    }

    .messages-clock {
      color: rgba(0,0,0, .6);
      display: flex;
      flex-grow: 1;
      width: 100%;
      align-items: center;

      div {
        display:flex;
        align-items: center;
        position: relative;
        top: 3px;
      }

      svg {
        font-size: 1.5rem !important;
        margin-right: .2rem;
      }

      small {
        font-size: 1.35rem;
      }
    }
  }

  .novo-atendimento {
    position: fixed;
    z-index: 99999999;
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    background: #ffffff;
    top: 24px;
    left: auto;
    right: 24px;
    margin: 8px;
    border-radius: 4px 4px 0 0;
    margin-top: 24px;
    padding: 6px 24px;

    &:after {
      width: 100%;
      height: 24px;
      background: #2f4050;
      position: absolute;
      content: "Passe o mouse para registrar o atendimento";
      bottom: -24px;
      left: 0;
      border-radius: 0 0 5px 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 1.2rem;
      box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
      transition: all .5s ease;
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-iteration-count: infinite;
      animation-name: pulse;
    }

    &>div:nth-child(2) {
      display: none;
    }

    &:hover {
      border-radius: 5px;



      &:after {
        display: none;
      }
    }

    fieldset {
      margin-top: 30px;
      padding-bottom: 20px;
      border-radius: 5px;
      background: #ECEFF1;
    }

    .head-atendimento {
      display: flex;
      align-items: center;
      margin-top: 6px;
      margin-bottom: 5px;

      .foto-cliente {
        background-image: url(data:image/svg+xml;base64,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);
        width: 4.5rem;
        height: 4.5rem;
        margin-right: 2rem;
        background-size: cover;
        position: relative;
        flex-shrink: 0;
        border-radius: 50%;
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center bottom;
        background-color: rgba(0, 0, 0, 0.2);

        img {
          max-width: 100%;
        }
      }

      .messages-columns {
        display: flex;
        flex-direction: column !important;
        align-items: flex-start;
        text-transform: uppercase;
        margin-left: 0;
        line-height: 1.3rem;
        font-weight: bold;

        .customer-name {
          color: rgba(0, 0, 0, 0.87);
          font-size: 1.4rem;
        }

        .messages-clock {
          color: rgba(0, 0, 0, 0.6);
          display: flex;
          -webkit-box-flex: 1;
          flex-grow: 1;
          width: 100%;
          margin-top: .3rem;
          align-items: center;

          svg {
            margin-right: 0.2rem;
            font-size: 1.5rem !important;
          }

          .tag-atendimento {
            font-size: 1.1rem;
            color: rgb(255, 255, 255);
            margin-right: 0.5rem;
            padding: 0.4rem 0.5rem;
            background: rgb(24, 144, 255);
            border-radius: 5px;
            margin-right: .5rem;
          }

          .timer {
            display: flex;
            align-items: center;
            small {
              font-size: 1.35rem;
            }
          }
        }
      }
    }
  }


  .tag-atendimento {
    font-size: 1.1rem;
    padding: .4rem .5rem;
    background: #1890ff;
    color: #ffffff;
    border-radius: 5px;
    margin-right: .5rem;
  }


  .color-select {
    position: relative;

    .color-title {
      width: 1.5rem;
      height: 1.5rem;
      position: absolute;
      background: black;
      display: block;
      top: 2.85rem;
      left: 1rem;
      border-radius: 50%;
    }

    select {
      padding-left: 3.2rem;

    }
  }


  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .animated.infinite {
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }

  .animated.delay-1s {
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
  }

  .animated.delay-2s {
    -webkit-animation-delay: 2s;
    animation-delay: 2s;
  }

  .animated.delay-3s {
    -webkit-animation-delay: 3s;
    animation-delay: 3s;
  }

  .animated.delay-4s {
    -webkit-animation-delay: 4s;
    animation-delay: 4s;
  }

  .animated.delay-5s {
    -webkit-animation-delay: 5s;
    animation-delay: 5s;
  }

  .animated.fast {
    -webkit-animation-duration: 800ms;
    animation-duration: 800ms;
  }

  .animated.faster {
    -webkit-animation-duration: 500ms;
    animation-duration: 500ms;
  }

  .animated.slow {
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
  }

  .animated.slower {
    -webkit-animation-duration: 3s;
    animation-duration: 3s;
  }

  .calendario-valor-diario {
    tr {

      td.fc-day-top  {
        text-align: center;

        &.fc-sun {
          color: #f86c6b !important;
        }

        .fc-day-number {
          float: none !important;
          font-size: 1.6rem !important;
        }

      }

      .fc-event-container {
        .fc-title {
          padding: 0 !important;
        }
      }

    }

    &.calendario-pesquisador {
      tr {
        td {
          .fc-time {
            display: none;
          }
        }
      }
    }
  }

  .total-calendar {
    text-align: right;
    margin-top: 10px;
  }



  @media (prefers-reduced-motion) {
    .animated {
      -webkit-animation: unset !important;
      animation: unset !important;
      -webkit-transition: none !important;
      transition: none !important;
    }
  }

  @-webkit-keyframes pulse {
    from {
      background-color: #1890ff;
    }

    50% {
      background-color: ${
        localStorage.getItem("@ecorban-app:theme")
          ? localStorage.getItem("@ecorban-app:theme")
          : "#2f4050"
      };
    }

    to {
      background-color: #1890ff;
    }
  }

  @keyframes pulse {
    from {
      background-color: #1890ff;
    }

    50% {
      background-color: ${
        localStorage.getItem("@ecorban-app:theme")
          ? localStorage.getItem("@ecorban-app:theme")
          : "#2f4050"
      };
    }

    to {
      background-color: #1890ff;
    }
  }

  .pulse {
    -webkit-animation-name: pulse;
    animation-name: pulse;
  }

  .title-basic-list {
    font-size: 1.4rem;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
    padding-left: .5rem;
    border-bottom: thin solid rgba(224,224,224, 1);
    padding-bottom: 1rem;
  }

  .basic-list {
    margin-bottom: 2rem;
    width: 50%;
    border-spacing: 0;
    border-collapse: collapse;

    tr {
      td {
        padding: 0 .5rem;
        color: rgba(0,0,0,0.85);
        font-size: 1.2rem;
        text-align: left;
        border-bottom: thin solid rgba(224,224,224, 1);
      }

      th {
        padding: 0 .5rem;
        color: rgba(0,0,0,0.85);
        font-size: 1.2rem;
        text-align: left;
        border-bottom: thin solid rgba(224,224,224, 1);
      }
    }
  }

  .white-space {
    padding: 2rem;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  }

  .error-title {
    padding-left: .5rem;
    font-size: 1.4rem;
    padding-bottom: 1rem;
    border-bottom: thin solid rgba(0,0,0,.1);
    margin-bottom: .5rem;
    font-weight: bold !important;
    color: #f86c6b !important;

    small {
      color: rgba(0,0,0,.6) !important;
      display: block;
      font-weight: normal !important;
      margin-top: .3rem;
    }
  }

  .basic-list-error {
    margin-bottom: 1rem;
    width: 100%;
    min-width: 70rem;
    border-spacing: 0;
    border-collapse: collapse;

    tr {
      td {
        padding: 0 .5rem;
        color: rgba(0,0,0,0.85);
        font-size: 1.2rem;
        text-align: left;
        border-bottom: thin solid rgba(224,224,224, 1);
      }

      th {
        padding: 0 .5rem;
        color: rgba(0,0,0,0.85);
        font-size: 1.2rem;
        text-align: left;
        border-bottom: thin solid rgba(224,224,224, 1);
      }
    }
  }

  .table-graph {
    display: flex;
  }

  .graph-table {
    width: 50%;
    min-height: 30rem;
  }

  .dashboard-panel {
    display: flex;
    justify-content: space-between;

    .dashboard-cell {
      position: relative;
      width: 49%;
    }
  }

  .ajuda-panel {
    display: flex;
    justify-content: space-between;

    .dashboard-cell:first-child {
      width: 70%;
    }

    .dashboard-cell:last-child {
      width: 29%;
    }
  }

  .video-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .video {
      padding: 3rem 2rem;
      border: thin solid rgba(0,0,0, .12);
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 48%;
      cursor: pointer;
      margin-bottom: 2rem;
      text-align: center;
      height: 14.6rem;

      p {
        font-weight: bold;
      }

      &:last-child {
        margin-bottom: 0;
      }

      i {
        font-size: 4rem;
        margin-bottom: 1rem;
        color: #1890ff;
      }
    }
  }

  .dashboard-selects {
    display: flex;
    position: absolute;
    z-index: 10;
    top: 1.5rem;

    select {
      margin-right: 1rem;
      min-width: 12rem;
      height: 3.2rem;
      font-size: 1.2rem;
      padding: .5rem 1rem;
      padding-right: 2.3rem;
    }
  }

  #general-pie-graph {
    margin-top: 3rem;
  }

  #ranking-vendas {
    margin-top: 3rem;
  }

  .container-table {
    padding: 2rem;
    background: #ffffff;
    border-radius: 3px;
    border: thin solid rgba(0,0,0, .1);
  }

  .modal-errors {
    div[role='document'] {
      max-width: 90%;
      min-width: 90%;
    }
  }

  #hot-display-license-info {
    display: none !important;
  }

  .handsontable {
    height: 40vh;
    overflow: hidden;
  }

  .aviso-importacao {
    padding: 2rem;
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 2rem;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);

    p {
      font-size: 1.3rem;
    }

    a {
      text-decoration: none;
      font-weight: bold;
    }

    span {
      display: block;
      &:not(:last-child) {
        margin-bottom: .2rem;
      }
    }
  }

  .titulo-simulador {
    align-items: center;
    height: 2rem;

    b {
      font-size: 1.6rem;
    }

    small {
      margin-left: 3rem;
      color: rgba(0,0,0, .5);
    }
  }

  .titulo-limite {
    font-size: 1.8rem;
    font-weight: bold;

    b {
      font-weight: bold;
      color: #1ab394 !important;
    }

    small {
      color: rgba(0,0,0, .5) !important;
    }
  }

  .botao-simulador {
      width: auto !important;
      font-size: 1.4rem !important;
      padding: 0.5rem 1rem;
      color: #ffffff;
      background: #1890ff;
      border-radius: 5px;
      cursor: pointer;
      font-weight: normal;
      border: 0;

      i {
        margin-right: .5rem;
        font-size: 1.6rem !important;
      }
    }

  .full-height {
    height: calc(100vh - 22rem);
  }

  .calendar td {
    padding: 0 !important;
    text-align: left;
  }

  .calendar tr span, .calendar tr a {
    padding: .5rem !important;
  }

  .calendar th {
    padding: .5rem 0 !important;
  }

  .calendar tr {
    height: auto !important;
  }

  .calendar .fc-list-table td {
    padding: 1rem !important;
    padding-bottom: .6rem !important;
  }

  .calendar .fc-list-table .fc-event-dot {
    padding: 0 !important;
  }

  .calendar .fc-toolbar .fc-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .calendar .fc-toolbar .fc-center button {
    background: #1890ff;
    color: #ffffff;
    border: 0;
    text-shadow: none;
    border-radius: 5px;
    font-size: 1.2rem !important;
    height: 2.9rem;
    padding-left: 3rem;
    position: relative;

    &:before {
      position: absolute;
      left: .8rem;
      top: .7rem;
      width: 1.5rem;
      height: 1.5rem;
      background-image: url(${Plus});
      background-repeat: no-repeat;
      content: "";
    }
  }

  .calendar .fc-event {
    border: 0;
    cursor: pointer;
  }

  .calendar .fc-list-table td:last-child {
    text-align: left;
  }

  #calendario-pesquisador .fc-other-month span {
    display: none;
  }

  #calendario-pesquisador .fc-other-month {
    background: rgba(0,0,0, .03);
  }

  .menu-comunicados a {
    display: block;
  }

  .menu-comunicados {
    .menu-left {
      display: flex;
      align-items: center;

      svg {
        font-size: 2.7rem !important;
      }
    }
  }

  .menu-calendario {
    li.opened {
      color: rgba(0,0,0, .8);
    }
  }

  .react-datepicker__navigation {
    width: 5rem !important;
    height: 3rem !important;
    top: .6rem !important;
    border: 0 !important;
  }

  .react-datepicker__navigation--previous {
    background: url(${ArrowLeft}) !important;
    background-size: 1rem !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }

  .react-datepicker__navigation--next {
    background: url(${ArrowRight}) !important;
    background-size: 1rem !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }


  .grafico-metas {
    width: 80rem;
    height: 11.5rem;
    position: absolute;
    padding: 1rem;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
    display: none;
    bottom: 0;
  }

  .mostrar-grafico-meta {
    position: relative;
    cursor: context-menu;

    i {
      font-size: 1.8rem;
    }
  }

  .mostrar-grafico-meta:hover {
    .grafico-metas {
      display: block;
    }
  }

  .divisoria-header {
    margin-left: .6rem;
    margin-right: .6rem;
    width: 1px;
    height: 15px;
    background: rgba(0,0,0, .2);
  }

  .flex-column {
    flex-direction: column;
  }

  .grafico-total-sales {
    width: 70rem;
  }

  #grafico-total-sales {
    height: 22rem;
  }

  .signal {
    position: absolute;
    top: 50%;
    margin-top: -.8rem;
    right: -1.35rem;
  }

  .el-rate__text {
    display: inline-block !important;
    margin-left: 1rem;
    position: relative;
    top: .3rem;
  }

  .tabela-organograma {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 1.2rem;

    .tabela-organograma-row {
      display: flex;
      flex-grow: 1;
      transition: all .5s ease;

      &:not(:last-child) {
        border-bottom: thin solid rgba(224, 224, 224, 1);
      }
    }

    p,b {
      padding: 1.3rem 2rem;
      font-size: 1.2rem;
      text-transform: uppercase;
      display: flex;
      align-items: center;

      small {
        font-size: 1rem;
        color: rgba(0,0,0, .6);
        margin-left: .5rem;
      }

      svg {
        font-size: 1.8rem !important;
        margin-right: .5rem;
        cursor: pointer;
        color: #1890ff;
      }

      .minimizar {
        color: #f86c6b;
      }
    }

    .expandir {
      align-items: center;
      position: relative;
      padding: 0.5rem .8rem;
      color: #ffffff;
      background: #1890ff;
      border-radius: 5px;
      cursor: pointer;
      height: 2.3rem;
      font-weight: normal;
      font-size: 1.2rem;
      text-transform: none;
      margin: 0 !important;
      margin-left: 1rem !important;
    }

    .diminuir {
      align-items: center;
      position: relative;
      padding: 0.5rem .8rem;
      color: #ffffff;
      background: #f86c6b;
      border-radius: 5px;
      cursor: pointer;
      height: 2.3rem;
      font-weight: normal;
      font-size: 1.2rem;
      text-transform: none;
      margin: 0 !important;
      margin-left: 1rem !important;
    }


    .value {
      text-align: right;
    }

    .display-none {
      display: none !important;
    }

    span {
      padding: 0 2rem;
      margin-bottom: 1.3rem;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      svg {
        font-size: 1.5rem !important;
        margin-right: .5rem;
      }

      img {
        width: 1.6rem;
        margin-right: .5rem;
      }

      small {
        font-size: 1rem;
        color: rgba(0,0,0, .6);
        margin-left: .5rem;
      }
    }

    .tabela-organograma-cell {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-basis: 0;
      min-width: 14rem;
    }
  }

  .flex-grow-1 {
    flex-grow: 1;
  }

  .flex-grow-8 {
    flex-grow: 8;
  }

  .flex-grow-2 {
    flex-grow: 2;
  }

  .flex-grow-3 {
    flex-grow: 3;
  }

  .flex-grow-4 {
    flex-grow: 4;
  }

  .border-left {
    border-left: thin solid rgba(224, 224, 224, 1);
  }

  .excluir-compromisso {
    float: right;
    height: 4.5rem;
    color: #ffffff;
    border: 0;
    background: #f86c6b !important;
    border-radius: 3px;
    position: relative;
    cursor: pointer;
    z-index: 2;
    padding: 0 2rem;
  }

  .autocomplete-select {
    width: 35rem;

    .disabled {
      &>div {
        border: .13rem solid #c2cfd6;
        background-color: rgb(235, 235, 228);
      }
    }

    div {
      font-weight: normal !important;
      font-size: 1.4rem;
    }

    &>div {
      margin-top: .3rem;

      &>div:nth-child(2) {
        box-shadow: none !important;

        &:hover {
          border-color: #2f4050;
        }
      }
    }

    input {
      margin-top: 0;
      height: 2.6rem;
      box-shadow: none !important;
      transition: none !important;
    }
  }

  .listagem-parcelas {
    padding-bottom: 1.3rem;
    border-bottom: thin solid rgba(0,0,0, .1);

    &:first-child {
      border-top: thin solid rgba(0,0,0, .1);
      padding-top: 1.5rem;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }

  .category-label {
    padding: .5rem 1rem;
    font-size: .7rem;
    border-radius: 3px;
    background-color: rgba(0,0,0, .1);
    font-weight: bold;
    color: rgba(0,0,0, .7);
    position: relative;
    cursor: context-menu;

    .tag-hover {
      left: calc(100% + 1rem);
      right: inherit;
      min-width: 100%;
      max-width: calc(100% + 10rem);
      font-size: 1rem !important;
      font-weight: 500;
      color: rgba(0,0,0, .7);
    }

    &:hover {
      .tag-hover {
        display: flex;
      }
    }

    &:not(:last-child) {
      margin-right: 1rem;
    }
  }

  .tableFooterExtrato {
    height: 56px;
  }

  .el-transfer-panel__list {
    padding-bottom: 46px !important;
  }

  .coluna-meta, .coluna-base-repasse {
    background: rgba(24,144,255,.15);
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .coluna-meta-amarela {
    background: #fff7dd;
  }

  .avada-kedrava {
    background: #fff7dd;
  }

  .tabela-Extrato {
    .expandir {
      font-size: 1rem !important;
      color: #ffffff;
      border-radius: 50%;
      background-color: #1890ff;
      width: 16px !important;
      line-height: 17px;
      height: 16px !important;
      display: block;
      margin: 0 auto;
    }

    .retrair {
      color: #ffffff;
      font-size: 1rem !important;
      border-radius: 50%;
      background-color: #f86c6b;
      width: 16px !important;
      line-height: 17px;
      height: 16px !important;
      display: block;
      margin: 0 auto;
      display: none;
    }

    .expandida {
      .retrair {
        display: block;
      }

      .expandir {
        display: none;
      }
    }

    .category-label {
      font-size: 1rem !important;
    }

    .font-weight-bold {
      font-weight: bold;
    }
  }

   .destaque {
      background: rgba(0,0,0, .05) !important;
    }

  .mini-button {
    padding: 6px;
    margin: 0;
    cursor: pointer;
    margin-left: 5px;
    border-radius: 5px;
    background: #7A6C5D;
    border: 0;
    position: absolute;

    svg {
      font-size: 1.8rem !important;
      color: #ffffff;
    }
  }

  @media(max-width: 1440px) {
    .cliente-card-header .cliente-card-summay {
      flex-wrap: wrap;
      padding-left: 0;
    }

    .cliente-card-header {
      align-items: center;
    }

    .cliente-card-header .cliente-card-summay p:nth-child(2n+2) {
      margin-right: 0;
    }


    .cliente-card-header .cliente-card-summay p:nth-child(4),
    .cliente-card-header .cliente-card-summay p:nth-child(3) {
      margin-top: .5rem;
    }

    .cliente-card-header .cliente-card-summay p {
      width: calc(50% - 2rem);
    }

    .dashboard-selects {
      position: relative;

      select {
        width: auto !important;
        min-width: auto !important;
      }
    }

  }

  #mapbox {
    border-radius: 5px;
    height: 40rem;
    width: 90rem;
  }

  .info {
    color: rgba(0,0,0, .7);
    float: right;
    bottom: .5rem;
    position: relative;
    cursor: context-menu;
    font-size: 1.3rem;
  }

  .campo-endereco {
    width: 25rem !important;
  }

  .campo-numero {
    width: 7rem !important;
  }

  .campo-ddd {
    width: 5rem !important;
  }

  .botao-pesquisador {
    width: auto !important;
  }

  .formulario-pesquisador {
    width: 100%;

    input, textarea, select {
      flex-grow: 0;
    }
  }

  .campo-estado {
    width: auto !important;
  }

  .botao-tipo-compromisso {
    align-items: center;
    position: relative;
    margin-top: 1.7rem;
    padding: 0.5rem 1rem;
    color: #ffffff;
    background: #1890ff;
    border-radius: 5px;
    cursor: pointer;
    height: 3.9rem;
    border: 0;
    margin-right: auto;
    margin-left: 1.5rem;
  }

  .labels-click {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .display-flex {
      flex-wrap: wrap;
    }

    p {
      margin-bottom: .5rem;
      font-size: 1.22rem;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
    }

    label {
      max-width: none;
      width: auto;
      flex-grow: 0;
      padding: 1rem 3rem;
      border: .13rem solid #c2cfd6;
      font-size: 1.1rem;
      border-radius: 5px;
      cursor: pointer;
      background: #ffffff;
      -webkit-box-shadow: 0px 10px 18px -6px rgba(0,0,0,0.05);
      -moz-box-shadow: 0px 10px 18px -6px rgba(0,0,0,0.05);
      box-shadow: 0px 10px 18px -6px rgba(0,0,0,0.05);
      margin-bottom: .5rem;
      text-align: center;
      transition: all .1s ease;

      &.jump {
        background: #f86c6b;
        color: #ffffff;
        border: .13rem solid #f86c6b;
      }

      &:hover {
        background: #1890ff;
        border-color: #1890ff;
        color: #ffffff;
      }

      &.finish {
        background: #1ab394;
        color: #ffffff;
        border: .13rem solid #1ab394;
      }
    }

    &.required {
      p {
        color: #f86c6b;
      }

      label {
        border: .13rem solid #f86c6b;
        color: #f86c6b;
      }
    }

    input:checked + label {
      background: #1890ff;
      border-color: #1890ff;
      color: #ffffff;
    }

    input {
      position: absolute;
      opacity: 0;
      z-index: -1;
      pointer-events: none;
      width: 0;
      height: 0;
    }
  }

  span.data-hora {
    color: rgba(0, 0, 0, 0.9) !important;
  }

  .time-hour {
    display: block;
  }

  @media(max-width: 1280px) {
    .cliente-card-header .cliente-card-summay p {
      width: calc(52% - 2rem);
    }
  }

  @media(max-width: 1024px) {

    .cliente-card-header {
      flex-direction: column;
    }

    .cliente-card-header .cliente-card-summay {
      margin-left: 0;
      width: 100%;
    }

    .cliente-card-header .break-tablet {
      width: 100%;
      margin-bottom: 1.5rem;
    }

    .cliente-card-header .cliente-card-summay:before {
      display: none;
    }

    .cliente-card-header .cliente-card-summay p {
      width: auto;
      margin: 0;
    }

    .cliente-card-header .cliente-card-summay p:not(:last-child) {
      margin-right: 1rem;
    }
  }

  #sidebar {


    &>div {
      -webkit-box-shadow: 5px 0px 5px -4px rgba(0,0,0,0.14);
    -moz-box-shadow: 5px 0px 5px -4px rgba(0,0,0,0.14);
    box-shadow: 5px 0px 5px -4px rgba(0,0,0,0.14);
    }
  }

  @media print {
    html, body, #root, .wrapper, .content-left {
      height: 100%  !important;
      width: 100% !important;
      overflow: initial  !important;
      left: 0 !important;
      margin: 0 !important;
      padding:  0 !important;
    }

    @page {
      size: A4;
      margin: 0.5cm;
    }

    button {
      display: none !important;
    }

    .botao-propostas {
      display: none !important;
    }

    body {
      overflow: initial !important;
      left: 0 !important;
      margin: 0 !important;
      padding:  0 !important;
      -webkit-print-color-adjust: exact;
      color: #000;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }

    table tr td:first-child,
    table tr td:last-child,
    table tr th:first-child,
    table tr th:last-child {
      display: none !important;
    }

    .hide-print {
      display: none !important;
    }

    * {
      position: relative;
      box-shadow: none !important;
      max-width: 1100px !important;
    }

    div {
      padding: 0 !important;
    }


    header,
    #topo-abb-bar,
    .app-bar,
    header.app-bar {
      display: none !important;
      opacity: 0 !important;
    }

    #main-content {
      z-index: 99999 !important;
      position: relative !important;
      overflow: initial !important;
      width: 100% !important;
      height: 100% !important;

    }

    /* #main-content > div {
        overflow: initial !important;;
        margin: 0 !important;
        position: relative !important;
      }
    */

    #main-content > div > div {
      border: 0 !important;
      background-color: transparent !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    #sidebar,
    #topo,
    #footer {
      display: none !important;
    }

    .modal.modal-big div[role='document'] {
      min-width: 100%;
      max-width: 100%;
      left: 0 !important;
      top: 0 !important;
      box-shadow: none !important;
    }


    .modal.modal-big-big div[role='document'] {
      min-width: 100%;
      max-width: 100%;
      left: 0 !important;
      top: 0 !important;
      box-shadow: none !important;
    }


    .modal div[role='document'] {
      box-shadow: none !important;
      border-radius: 0 !important;

    }

    .modal div[role='document'] .modalBody {
      max-height: 100%;
      padding: 0;
      background-color: transparent !important;
    }

    .modal div[role='document'] .modalHeader {
      display: none;
    }

    .modal > div {
      background-color: #ffffff;
    }
  }

  .tabs-icons {
    button {
      i {
        color: rgba(0,0,0, .6);
        font-size: 1.5rem !important;
        margin-right: .8rem;
      }

      span {
        display: flex;
        align-items: center;
      }
    }

    button[aria-selected=true] {
      i {
        color: #1890ff;
      }
    }
  }

  .field-password {
    text-transform: none !important;
  }

  .thumbs.call {
    padding: 0.5rem 0.8rem !important;
    border-radius: 5px !important;
    font-size: 1.2rem !important;
    margin: 0.2rem 0 !important;
    display: inline-block !important;
    cursor: pointer !important;
    background-color: #1890ff !important;
    color: #ffffff !important;
    margin-left: 1rem !important;
  }

  .user-acess-cell {
    color: rgba(0,0,0,0.54) !important;
    display: block;
  }

  .pt-1 {
    padding-top: 0.5rem;
  }

  .pt-2 {
    padding-top: 0.8rem;
  }

  .pt-3 {
    padding-top: 1.1rem;
  }

  .label-description {
  max-width: 30rem;
  font-size: 1.1rem;
  }

  .label-blue {
   color: #1b6cd6;
  }

  .form-propostas-info-beneficios {
    max-width: 25%;
  }

  .modalBody form .buttonSubmitDisabled {
    background-color: #e0e0e0 !important;
    color: #717171 !important;
    cursor: not-allowed !important;
  }

  .therm-replica-convenio {
    width: calc(100% - 48px); // 48px é o tamanho do checkbox
  }
  table{
    thead, tbody{
      tr{
        .metas-detail-date {
          padding-right: 1rem !important;
          padding-left: 1rem !important;
        }
        .metas-detail-table-buttons {
          width: 8rem;
          padding-right: 3px !important;
          padding-left: 3px !important;
        }
      }
    }
  }
  div {
    .select{
      height: 4rem;
      font-size: 1.4rem;
      padding: 1rem;
      width: 100%;
    }
    ul{
      .option{
        font-weight: 500;
        font-size: 1.3rem;
      }
      .inactived {
        color: #494949;
      }
      .blocked {
        color: #d12120;
        .icon {
         font-size: 1.6rem !important;
         margin-left: 1rem;
        }
      }
    }
  }
  fieldset {
    .fix-select-width {
     width: 340px;
    }
  }
  label {
      .select-fake {
        background-color: #ffffff;
        height: 4rem;
        font-size: 1.4rem;
        padding: 1rem;
        color: rgba(0, 0, 0, 0.8);
        border: .13rem solid #c2cfd6;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        flex-grow: 1;
        width: 100%;
        margin-top: .3rem;
        border-radius: 3px;
        text-rendering: optimizeLegibility !important;
        -webkit-font-smoothing: antialiased !important;
        transition: all .3s ease;
        text-transform: uppercase !important;
        resize: none;
        appearance: none;
          -webkit-appearance: none;

        &:hover,
        &:focus {
          border-color: #2f4050;
        }

        &:focus {
          -webkit-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
          -moz-box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
          box-shadow: 0px 0px 5px 0px rgba(47,64,80,0.8);
        }

        &:last-child {
          margin-bottom: 0;
        }

        .icon {
         font-size: 1.6rem !important;
        }
      }
    }

  .select-fake div div {
    padding: 0;
  }
  .transfer-checkbox {
    width: 46%;
  }

.el-checkbox__label{
  span{
    .login_blocked {
      color: #d12120;
      .icon {
        font-size: 1.6rem !important;
      }
    }
  }
}
.tag-recebimento {
  color: #fff;
  position: relative;
  background-color: #ff784f;
  padding: .6rem;
  display: inline-block;
  text-align: center;
  border-radius: 3px;
  font-size: 1.2rem !important;
  font-weight: 700;
  cursor: context-menu;

    .tag-hover {
      left: calc(100% + 1rem);
      right: inherit;
      min-width: 100px
      max-width: 120px;
      font-size: 1rem !important;
      font-weight: 500;
      color: rgba(0,0,0, .7);
    }

    &:hover {
      .tag-hover {
        display: flex;
      }
    }

    &:not(:last-child) {
      margin-right: 1rem;
    }
}
.dialog-selectRateio {
  max-height: 40rem;
  min-width: 40rem;
}
div {
  .dialog-ActionRateio {
    justify-content: space-between;
    margin-top: 2px;
    margin-right: 30px;
    margin-left: 30px;
  }
}

.infoRateio {
  color: rgba(0,0,0,.5);
  display: flex;
  justify-content: space-between;
  border-top: solid 1px rgba(0, 0, 0, 0.12);
  padding-top: 1rem;
}

.modal-local-working {
  .avatar-show {
    width: 6rem;
    height: 6rem;
    overflow: hidden;
    border-radius: 50%;
    img {
      width: 100%;
    }
  }
  .user-info {
    font-weight: 500;
    display: flex;
    margin-left: 1rem;
    flex-direction: column;
    color: rgba(0,0,0,0.7);

    .user-title {
       font-size : 1.4rem;
       margin-top: 6px;
       margin-bottom: 2px;
    }

    .user-details {
      font-size : 1.2rem;
      color: rgba(0,0,0,0.65);
    }
  }
}
.blocked {
  color: #d12120;
}
.local-working-table tbody td button {
    padding: 0 !important;
    min-width: 0 !important;
    min-height: 0 !important;
}

.local-working-table {
  button {
    span {
        svg {
          font-size:1.8rem !important;
        }
      }
  }
}
.center-item {
  align-items: center;
}
.participating-user {
  margin-top: 8px;
  width: 150px;
  .checkbox-label {
    margin: 0;
  }
}

.participating-user-list {
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: row;
  padding: .5rem 0;

 .tag{
  position: relative;
  cursor: default;
 }

  .part {
    border-top: dotted 2px #2f4050;
    margin-top: 1px;
    padding-top: 1px;
  }
}
.salesTableWidth {
   width: calc(100% - 70rem) !important;
}

  .cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cropper-container img{display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-canvas,.cropper-wrap-box{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:.5}.cropper-view-box{display:block;height:100%;outline-color:rgba(51,153,255,.75);outline:1px solid #39f;overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}.cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}.cropper-center:after,.cropper-center:before{background-color:#eee;content:" ";display:block;position:absolute}.cropper-center:before{height:1px;left:-3px;top:0;width:7px}.cropper-center:after{height:7px;left:0;top:-3px;width:1px}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){.cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){.cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){.cropper-point.point-se{height:5px;opacity:.75;width:5px}}.cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:" ";display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}.cropper-invisible{opacity:0}.cropper-bg{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC")}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}
`;




// WEBPACK FOOTER //
// ./src/styles/global.js